import { PayloadAction } from '../../../store.model';
import { ActionType } from '../transcript-import-dialog.action';
import {
    defaultState,
    TranscriptImportDialogState,
} from '../transcript-import-dialog.state';

import { Reload, ReloadResult } from './reload.action';

export function reloadReducer(
    state: TranscriptImportDialogState,
    action: PayloadAction<ActionType, Reload>,
): TranscriptImportDialogState {
    return {
        ...defaultState(),
        userId: action.payload.userId,
        selectedUserId: action.payload.selectedUserId,
    };
}

export function reloadResultReducer(
    state: TranscriptImportDialogState,
    action: PayloadAction<ActionType, ReloadResult>,
): TranscriptImportDialogState {
    return {
        ...state,
        selectedUserName: action.payload.selectedUserName,
    };
}
